import { useQuery } from '@tanstack/react-query';
import ToursOptionApi from '@/features/dashboard/tourOptions/api/tourOptionsApi.ts';
import { TourOptionDto } from '@/features/dashboard/tourOptions/types/TourOptionDto.ts';
import { useTourBuilderContext } from '@/features/dashboard/tourConfig/contexts/TourBuilderContext.tsx';
import { toast } from 'sonner';
import { tourOptionsApiQueryKeys } from '@/features/dashboard/tourOptions/api/tourOptionsApi.queryKeys.ts';

export default function useGetTourOptions(tourId: string) {
  const { state, setTourOptions } = useTourBuilderContext();
  return useQuery({
    queryFn: () => ToursOptionApi.getAll(tourId),
    queryKey: tourOptionsApiQueryKeys.byTourId(tourId),
    // onSuccess: (dto: TourOptionDto[]) => {
    //   setTourOptions(dto);
    // },
    // onError: (error: Error) => {
    //   toast.error('Wystąpił błąd', {
    //     description:
    //       error.message ||
    //       'Wystąpił błąd podczas odczytywania opcji tego wyjazdu.',
    //   });
    // },
  });
}
